var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";
import { FieldType } from "@ngx-formly/core";
import { ToasterService } from "angular2-toaster";
import { WatcherService } from "app/services/watcher.service";
var FormlyFieldUpdateOwner = /** @class */ (function (_super) {
    __extends(FormlyFieldUpdateOwner, _super);
    function FormlyFieldUpdateOwner(watcherService, toasterService) {
        var _this = _super.call(this) || this;
        _this.watcherService = watcherService;
        _this.toasterService = toasterService;
        _this.operators = [];
        return _this;
    }
    Object.defineProperty(FormlyFieldUpdateOwner.prototype, "assignToEmail", {
        get: function () {
            var _this = this;
            if (this.operators.length === 0) {
                return false;
            }
            return this.operators.find(function (o) { return o.id === _this.assignTo; }).email;
        },
        enumerable: true,
        configurable: true
    });
    FormlyFieldUpdateOwner.prototype.ngOnChanges = function (changes) {
        this.assignTo = this.field.templateOptions.operatorId
            ? this.field.templateOptions.operatorId
            : "unassigned";
    };
    FormlyFieldUpdateOwner.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this;
                        _c = (_b = [
                            {
                                email: "UNASSIGNED",
                                id: "unassigned",
                            }
                        ]).concat;
                        return [4 /*yield*/, this.watcherService.retrieveOperators().toPromise()];
                    case 1:
                        _a.operators = _c.apply(_b, [(_d.sent())]);
                        this.ngOnChanges(this.field.templateOptions.operatorId);
                        return [2 /*return*/];
                }
            });
        });
    };
    FormlyFieldUpdateOwner.prototype.submit = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, e_2, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.field.templateOptions.submitDisabled) {
                            this.field.templateOptions.change(this.field, $event);
                            this.s.writeValue($event ? $event.id : 'unassigned');
                            return [2 /*return*/];
                        }
                        if (!this.assignTo) return [3 /*break*/, 9];
                        if (!(this.assignTo === "unassigned")) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.watcherService.deleteWatcher(this.field.templateOptions.id).toPromise()];
                    case 2:
                        _a.sent();
                        this.toasterService.pop("success", "Success");
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.toasterService.pop("error", "Error");
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.watcherService
                                .setWatcher(this.field.templateOptions.id, this.assignTo)
                                .toPromise()];
                    case 6:
                        _a.sent();
                        this.toasterService.pop("success", "Success");
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.toasterService.pop("error", "Error");
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 14];
                    case 9:
                        this.assignTo = "unassigned";
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, this.watcherService.deleteWatcher(this.field.templateOptions.id).toPromise()];
                    case 11:
                        _a.sent();
                        this.toasterService.pop("success", "Success");
                        return [3 /*break*/, 13];
                    case 12:
                        e_3 = _a.sent();
                        this.toasterService.pop("error", "Error");
                        return [3 /*break*/, 13];
                    case 13:
                        this.s.writeValue(this.assignTo);
                        _a.label = 14;
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    return FormlyFieldUpdateOwner;
}(FieldType));
export { FormlyFieldUpdateOwner };
